// extracted by mini-css-extract-plugin
export default {"root":"NoticeToolBar_root__eXaJb","button":"NoticeToolBar_button__3-UyB"};